// extracted by mini-css-extract-plugin
module.exports = {"container":"ProposalList_container__U6q1p"};